import swal from 'sweetalert2';
import { updateSettingsFromTextboxJSON, updateSettingsFromNumberJSON, updateSettingsFromTextareaJSON, updateSettingsFromNameJSON, updateSettingsFromChoiceJSON, updateSettingsFromLocationJSON, updateSettingsFromDistanceJSON, updateSettingsFromPaymentJSON, updateSettingsFromYesnoJSON, updateSettingsFromCoRelationJSON, updateSettingsFromAddressJSON, updateSettingsFromEmailJSON, updateSettingsFromWebsiteJSON, updateSettingsFromCurrencyJSON, updateSettingsFromPhoneJSON, updateSettingsFromDateJSON, updateSettingsFromTimeJSON, updateSettingsFromRatingJSON, updateSettingsFromScaleJSON, updateSettingsFromSignatureJSON, updateSettingsFromAreaJSON, updateSettingsFromBarcodeJSON, updateSettingsFromFileJSON, updateSettingsFromHeaderJSON, updateSettingsFromContentJSON, updateDesignsFromLayoutJSON, updateDesignsFromBackgroundJSON, updateDesignsFromFontsJSON, updateDesignsFromButtonsJSON } from './updateSettingsFromElementJSON';
import { textboxInput, textareaInput, locationInput, areaMapInput, distanceInput, nameInput, choiceCheckboxInput, coRelationDropdownInput, paymentRadioInput, choiceRadioInput, choiceDropdownInput, addressInput, yesnoInput, phoneInput, dateInput, timeInput, scaleInput, signatureInput, barcodeInput, emailInput, numberInput, websiteInput, currencyInput, ratingInput, fileInput, pagebreakInput, headerInput, contentInput, formSubmissionInput } from './elements';
import { textboxInputSettings, textareaInputSettings, locationInputSettings, areaMapInputSettings, scaleInputSettings, signatureInputSettings, barcodeInputSettings, distanceInputSettings, nameInputSettings, choiceInputSettings, coRelationInputSettings, paymentInputSettings, yesnoInputSettings, addressInputSettings, emailInputSettings, numberInputSettings, websiteInputSettings, currencyInputSettings, phoneInputSettings, dateInputSettings, timeInputSettings, ratingInputSettings, fileInputSettings, headerInputSettings, contentInputSettings, layoutSettings, backgroundSettings, fontsSettings, buttonsSettings } from './elementSettings';

const $ = window.$;

export function addSettingsToElements(div, element, elementSettings, elementIndex) {
	$(div).find('._activate-sidebar').click(function () {
		$('#_single-element-settings').html(elementSettings);
		var index = $(this).parent().parent().parent().data('index');
		$('#_single-element-settings').toggleClass('open');
		$('._form-outlet').toggleClass('_single-element-settings-open');
		$('body').append('<div id="sidenav-overlay" class="_single-element-settings-overlay"></div>');
		$('#sidenav-overlay._single-element-settings-overlay').click(function() {
			$('#_single-element-settings').toggleClass('open');
			$('#_single-element-settings').find('input').each(function() {
				$(this).val('');
			});
			$('._form-outlet').toggleClass('_single-element-settings-open');
			$(this).remove();
			$('#_form-settings').removeClass('show');
		});

		if (element == 'textboxInput') {
			updateSettingsFromTextboxJSON(index);
			$('#_single-element-settings').find('#saveBtn').attr('onclick', 'saveTextboxJSONFromSettings(' + index + ')');
			$('#_single-element-settings').find('._go-to-form-elems').attr('onclick', 'closeFormElement()');
		} else if (element == 'textareaInput') {
			updateSettingsFromTextareaJSON(index);
			$('#_single-element-settings').find('#saveBtn').attr('onclick', 'saveTextareaJSONFromSettings(' + index + ')');
			$('#_single-element-settings').find('._go-to-form-elems').attr('onclick', 'closeFormElement()');
		} else if (element == 'nameInput') {
			updateSettingsFromNameJSON(index);
			$('#_single-element-settings').find('#saveBtn').attr('onclick', 'saveNameJSONFromSettings(' + index + ')');
			$('#_single-element-settings').find('._go-to-form-elems').attr('onclick', 'closeFormElement()');
		} else if (element == 'choiceCheckboxInput') {
			updateSettingsFromChoiceJSON(index);
			$('#_single-element-settings ._add-choice-option > a._add-button').attr('onclick', 'addNewChoice()');
			$('#_single-element-settings').find('#saveBtn').attr('onclick', 'saveChoiceJSONFromSettings(' + index + ')');
			$('#_single-element-settings').find('._go-to-form-elems').attr('onclick', 'closeFormElement()');
		}	else if (element == 'paymentRadioInput') {
			updateSettingsFromPaymentJSON(index);
			$('#_single-element-settings ._add-payment-option > a._add-button').attr('onclick', 'addNewProduct()');
			$('#_single-element-settings').find('#saveBtn').attr('onclick', 'savePaymentJSONFromSettings(' + index + ')');
			$('#_single-element-settings').find('._go-to-form-elems').attr('onclick', 'closeFormElement()');
		} else if (element == 'yesnoInput') {
			updateSettingsFromYesnoJSON(index);
			$('#_single-element-settings').find('#saveBtn').attr('onclick', 'saveYesnoJSONFromSettings(' + index + ')');
			$('#_single-element-settings').find('._go-to-form-elems').attr('onclick', 'closeFormElement()');
		} else if (element == 'coRelationDropdownInput') {
			updateSettingsFromCoRelationJSON(index);
			$('#_single-element-settings').find('#saveBtn').attr('onclick', 'saveCoRelationJSONFromSettings(' + index + ')');
			$('#_single-element-settings').find('._go-to-form-elems').attr('onclick', 'closeFormElement()');
		} else if (element == 'addressInput') {
			updateSettingsFromAddressJSON(index);
			$('#_single-element-settings').find('#saveBtn').attr('onclick', 'saveAddressJSONFromSettings(' + index + ')');
			$('#_single-element-settings').find('._go-to-form-elems').attr('onclick', 'closeFormElement()');
		} else if (element == 'emailInput') {
			updateSettingsFromEmailJSON(index);
			$('#_single-element-settings').find('#saveBtn').attr('onclick', 'saveEmailJSONFromSettings(' + index + ')');
			$('#_single-element-settings').find('._go-to-form-elems').attr('onclick', 'closeFormElement()');
		} else if (element == 'numberInput') {
			updateSettingsFromNumberJSON(index);
			$('#_single-element-settings').find('#saveBtn').attr('onclick', 'saveNumberJSONFromSettings(' + index + ')');
			$('#_single-element-settings').find('._go-to-form-elems').attr('onclick', 'closeFormElement()');
		} else if (element == 'websiteInput') {
			updateSettingsFromWebsiteJSON(index);
			$('#_single-element-settings').find('#saveBtn').attr('onclick', 'saveWebsiteJSONFromSettings(' + index + ')');
			$('#_single-element-settings').find('._go-to-form-elems').attr('onclick', 'closeFormElement()');
		} else if (element == 'currencyInput') {
			updateSettingsFromCurrencyJSON(index);
			$('#_single-element-settings').find('#saveBtn').attr('onclick', 'saveCurrencyJSONFromSettings(' + index + ')');
			$('#_single-element-settings').find('._go-to-form-elems').attr('onclick', 'closeFormElement()');
		} else if (element == 'phoneInput') {
			updateSettingsFromPhoneJSON(index);
			$('#_single-element-settings').find('#saveBtn').attr('onclick', 'savePhoneJSONFromSettings(' + index + ')');
			$('#_single-element-settings').find('._go-to-form-elems').attr('onclick', 'closeFormElement()');
		} else if (element == 'dateInput') {
			updateSettingsFromDateJSON(index);
			$('#_single-element-settings').find('#saveBtn').attr('onclick', 'saveDateJSONFromSettings(' + index + ')');
			$('#_single-element-settings').find('._go-to-form-elems').attr('onclick', 'closeFormElement()');
		} else if (element == 'timeInput') {
			updateSettingsFromTimeJSON(index);
			$('#_single-element-settings').find('#saveBtn').attr('onclick', 'saveTimeJSONFromSettings(' + index + ')');
			$('#_single-element-settings').find('._go-to-form-elems').attr('onclick', 'closeFormElement()');
		} else if (element == 'ratingInput') {
			updateSettingsFromRatingJSON(index);
			$('#_single-element-settings').find('#saveBtn').attr('onclick', 'saveRatingJSONFromSettings(' + index + ')');
			$('#_single-element-settings').find('._go-to-form-elems').attr('onclick', 'closeFormElement()');
		} else if (element == 'scaleInput') {
			updateSettingsFromRatingJSON(index);
			$('#_single-element-settings').find('#saveBtn').attr('onclick', 'saveScaleJSONFromSettings(' + index + ')');
			$('#_single-element-settings').find('._go-to-form-elems').attr('onclick', 'closeFormElement()');
		} else if (element == 'fileInput') {
			updateSettingsFromFileJSON(index);
			$('#_single-element-settings').find('#saveBtn').attr('onclick', 'saveFileJSONFromSettings(' + index + ')');
			$('#_single-element-settings').find('._go-to-form-elems').attr('onclick', 'closeFormElement()');
		} else if (element == 'headerInput') {
			updateSettingsFromHeaderJSON();
			$('#_single-element-settings').find('#saveBtn').attr('onclick', 'saveHeaderJSONFromSettings()');
			$('#_single-element-settings').find('._go-to-form-elems').attr('onclick', 'closeFormElement()');
		} else if (element == 'contentInput') {
			updateSettingsFromContentJSON(index);
			$('#_single-element-settings').find('#saveBtn').attr('onclick', 'saveContentJSONFromSettings(' + index + ')');
			$('#_single-element-settings').find('._go-to-form-elems').attr('onclick', 'closeFormElement()');
		} else if (element == 'locationInput') {
			updateSettingsFromLocationJSON(index);
			$('#_single-element-settings').find('#saveBtn').attr('onclick', 'saveLocationJSONFromSettings(' + index + ')');
			$('#_single-element-settings').find('._go-to-form-elems').attr('onclick', 'closeFormElement()');
		} else if (element == 'distanceInput') {
			updateSettingsFromScaleJSON(index);
			$('#_single-element-settings').find('#saveBtn').attr('onclick', 'saveDistanceJSONFromSettings(' + index + ')');
			$('#_single-element-settings').find('._go-to-form-elems').attr('onclick', 'closeFormElement()');
		} else if (element == 'signatureInput') {
			updateSettingsFromSignatureJSON(index);
			$('#_single-element-settings').find('#saveBtn').attr('onclick', 'saveSignatureJSONFromSettings(' + index + ')');
			$('#_single-element-settings').find('._go-to-form-elems').attr('onclick', 'closeFormElement()');
		} else if (element == 'barcodeInput') {
			updateSettingsFromBarcodeJSON(index);
			$('#_single-element-settings').find('#saveBtn').attr('onclick', 'saveBarcodeJSONFromSettings(' + index + ')');
			$('#_single-element-settings').find('._go-to-form-elems').attr('onclick', 'closeFormElement()');
		} else if (element == 'areaMapInput') {
			updateSettingsFromAreaJSON(index);
			$('#_single-element-settings').find('#saveBtn').attr('onclick', 'saveAreaJSONFromSettings(' + index + ')');
			$('#_single-element-settings').find('._go-to-form-elems').attr('onclick', 'closeFormElement()');
		}
	});
	$("._form-details").sideNav('hide');
	$("._form-designs").sideNav('hide');
	$(div).find('._activate-sidebar').click();
}

function addDesignsToElements(data, elementName, elementSettings){
	$('#_single-element-design-settings').html(elementSettings);
		$('#_single-element-design-settings').toggleClass('open');
		$('._form-outlet').toggleClass('_single-element-design-settings-open');
		$('body').append('<div id="sidenav-overlay" class="_single-element-design-settings-overlay"></div>');
		$('#sidenav-overlay._single-element-design-settings-overlay').click(function() {
			$('#_single-element-design-settings').toggleClass('open');
			$('#_single-element-design-settings').find('input').each(function() {
				$(this).val('');
			});
			$('._form-outlet').toggleClass('_single-element-design-settings-open');
			$(this).remove();
			$('#_form-settings').removeClass('show');
		});

		if (elementName == 'layout') {
			updateDesignsFromLayoutJSON(elementName);
			$('#_single-element-design-settings').find('#saveBtn').attr('onclick', 'saveLayoutJSONFromDesigns("layout")');
			$('#_single-element-design-settings').find('._go-to-design-elems').attr('onclick', 'closeDesignElement()');
		} else if (elementName == 'background') {
			updateDesignsFromBackgroundJSON(elementName);
			$('#_single-element-design-settings').find('#saveBtn').attr('onclick', 'saveBackgroundJSONFromDesigns("background")');
			$('#_single-element-design-settings').find('._go-to-design-elems').attr('onclick', 'closeDesignElement()');
		}else if (elementName == 'fonts') {
			updateDesignsFromFontsJSON(elementName);
			$('#_single-element-design-settings').find('#saveBtn').attr('onclick', 'saveFontsJSONFromDesigns("fonts")');
			$('#_single-element-design-settings').find('._go-to-design-elems').attr('onclick', 'closeDesignElement()');
		} else if (elementName == 'buttons') {
			updateDesignsFromButtonsJSON(elementName);
			$('#_single-element-design-settings').find('#saveBtn').attr('onclick', 'saveButtonsJSONFromDesigns("buttons")');
			$('#_single-element-design-settings').find('._go-to-design-elems').attr('onclick', 'closeDesignElement()');
		}
	$("._form-details").sideNav('hide');
}

function closeDesignElement(){
	$('._go-to-design-elems').parents('._top-menu-holder').parent().sideNav('hide');
	$('._form-holder > ._form-designs').click();
}

function closeFormElement(){
	$('._go-to-form-elems').parents('._top-menu-holder').parent().sideNav('hide');
	$('._form-holder ._form-element-add').click();
}

$(document).ready(function() {
	var formDetailsSettings = '<div id="_form-details-settings" class="side-nav"><div class="row"><div class="input-field col s12"> <input id="form_name" type="text" class="validate"> <label for="form_name">Form Name</label></div><div class="input-field col s12"><textarea id="form_description" class="materialize-textarea"></textarea><label for="form_description">Form Description</label></div><div class="input-field col s6"> <input id="valid_from" type="date" class="datepicker"> <label class="active" for="valid_from">Valid From</label></div><div class="input-field col s6"> <input id="valid_to" type="date" class="datepicker"> <label class="active" for="valid_to">Valid To</label></div><div class="col s6"> <input type="checkbox" id="offline_data" /> <label for="offline_data">Offline Data</label></div><div class="col s6"> <input type="checkbox" id="geolocation" /> <label for="geolocation">Geolocation</label></div><div class="col s6"> <input type="checkbox" id="deletable" /> <label for="deletable">Can be deleted?</label></div><div class="col s12 center-align"> <a class="waves-effect waves-light btn" id="_save-form-details-btn">Save</a></div></div></div>';
	var formSettings = '<div id="_form-settings" class="side-nav"><div class="col s12 header"> Publish Form</div><div class="col s12 publish-setiings-container"><div class="col s12 sub-header-container"><div class="col s12 sub-header-lg">Embed in your site</div><div class="col s12 sub-header-sm">Simply copy and paste the code below in your html.</div></div><div class="col s12 text-holder"><textarea rows="4" cols="50"></textarea><button>Iframe</button></div><div class="col s12 link-share"><div class="col s12 share-link-header">Share a link</div><div class="col s12 share-link-sub-header">Use this URL to create a hyperlink to your form</div> <input type="text" name="" class="col s12"></div><div class="col s12 share-social-link"><div class="col s12 share-social-header">Share on social media</div><div class="col s12 share-socail-sub-header">Share the link to your form on these social media sites</div><div class="col s12 share-social-cards"><div>FB</div><div>TW</div><div>LN</div><div>EM</div><div>CP</div></div></div></div></div>'
	var addElementsSettings = '<div id="_add-elements-settings" class="side-nav"><div class="row"><div class="col s12"><div id="_open-form-settings" class="col s4">Form</div><div id="_open-settings" class="col s4">Settings</div><div id="_open-designs" class="col s4">Designs</div></div></div><div class="row"><div class="col s12"><p style="font-size: 24px; font-weight: 600;">Input</p></div><div class="col s6"> <a class="waves-effect waves-light btn _mtb5 _w100 _sidebarBtn" id="textboxAddBtn" >Textbox</a></div><div class="col s6"> <a class="waves-effect waves-light btn _mtb5 _w100 _sidebarBtn" id="textareaAddBtn" >Textarea</a></div><div class="col s6"> <a class="waves-effect waves-light btn _mtb5 _w100 _sidebarBtn" id="nameAddBtn" >Name</a></div><div class="col s6"> <a class="waves-effect waves-light btn _mtb5 _w100 _sidebarBtn" id="choiceAddBtn" >Choice</a></div><div class="col s6"> <a class="waves-effect waves-light btn _mtb5 _w100 _sidebarBtn" id="addressAddBtn" >Address</a></div><div class="col s6"> <a class="waves-effect waves-light btn _mtb5 _w100 _sidebarBtn" id="yesnoAddBtn" >Yes/No</a></div><div class="col s6"> <a class="waves-effect waves-light btn _mtb5 _w100 _sidebarBtn" id="phoneAddBtn" >Phone</a></div><div class="col s6"> <a class="waves-effect waves-light btn _mtb5 _w100 _sidebarBtn" id="dateAddBtn" >Date</a></div><div class="col s6"> <a class="waves-effect waves-light btn _mtb5 _w100 _sidebarBtn" id="timeAddBtn" >Time</a></div><div class="col s6"> <a class="waves-effect waves-light btn _mtb5 _w100 _sidebarBtn" id="emailAddBtn" >Email</a></div><div class="col s6"> <a class="waves-effect waves-light btn _mtb5 _w100 _sidebarBtn" id="numberAddBtn" >Number</a></div><div class="col s6"> <a class="waves-effect waves-light btn _mtb5 _w100 _sidebarBtn" id="websiteAddBtn" >Website</a></div><div class="col s6"> <a class="waves-effect waves-light btn _mtb5 _w100 _sidebarBtn" id="currencyAddBtn" >Currency</a></div><div class="col s6"> <a class="waves-effect waves-light btn _mtb5 _w100 _sidebarBtn" id="paymentAddBtn" >Payment</a></div><div class="col s6"> <a class="waves-effect waves-light btn _mtb5 _w100 _sidebarBtn" id="ratingAddBtn" >Rating</a></div><div class="col s6"> <a class="waves-effect waves-light btn _mtb5 _w100 _sidebarBtn" id="fileAddBtn" >File Upload</a></div><div class="col s6"> <a class="waves-effect waves-light btn _mtb5 _w100 _sidebarBtn" id="pagebreakAddBtn" >Page Break</a></div></div><div class="row"><div class="col s12"><p style="font-size: 24px; font-weight: 600;">Layout</p></div><div class="col s6"> <a class="waves-effect waves-light btn _mtb5 _w100 _sidebarBtn" id="headerAddBtn" >Header</a></div><div class="col s6"> <a class="waves-effect waves-light btn _mtb5 _w100 _sidebarBtn" id="contentAddBtn" >Content</a></div></div></div>';
	var singleElementSettings = '<div id="_single-element-settings" class="side-nav"></div>';
	var formHolder = '<div class="_form-holder"><div class="container _mb10 _form-details" data-activates="_form-details-settings"><div class="row"><div class="col s12 _form-name"><p class="_form-name-element">Untitled</p></div></div></div><div class="container _mb10 _header-container"></div><div class="container _mb10 _element-container" id="elementContainer"></div><div class="container _mb10"><div class="row"><div class="col s12 _form-element-add" data-activates="_add-elements-settings"> <i class="material-icons">add_circle_outline</i></div></div></div></div>';

	$.getScript('/js/formBuilder/saveElementJSONFromSettings.js');

	//variables
	var headerContainer = $('._form-holder ._header-container');
	var formContainer = $('._form-holder ._element-container');
	var elementIndex = 0;

	// initializations
	$('.modal').modal();

	// initialize signaturepad
	$('#smoothed').signaturePad({
		drawOnly:true,
		drawBezierCurves:true,
		lineTop:200
	});

	$('.datepicker').pickadate({
		selectMonths: true, // Creates a dropdown to control month
		selectYears: 15,
		container: 'body'
	});

	$('.datepicker-here').datepicker({language: 'en', dateFormat: 'dd/mm/yyyy'});

	if(window.innerWidth < 500){
		$("._form-element-add").sideNav({
			menuWidth: 200,
			onOpen: function(el) {
				$('._form-outlet').animate({'left': '0px'});
				$('._bottom-fixed-footer').animate({'left': '200px'});
				$('#_form-settings').removeClass('show');
			},
			onClose: function(el) {
				$('._form-outlet').animate({'left': '0'});
				$('._bottom-fixed-footer').animate({'left': '0'});
				$('#_form-settings').removeClass('show');
			},
		});

		$("._form-details").sideNav({
			menuWidth: 200,
			onOpen: function(el) {
				$('._form-outlet').animate({'left': '0px'});
				$('._bottom-fixed-footer').animate({'left': '200px'});
				$('#_form-settings').removeClass('show');
			},
			onClose: function(el) {
				$('._form-outlet').animate({'left': '0'});
				$('._bottom-fixed-footer').animate({'left': '0'});
				$("._top-menu-holder").removeClass('show');
			},
		});

		$("._form-designs").sideNav({
			menuWidth: 200,
			onOpen: function(el) {
				$('._form-outlet').animate({'left': '0px'});
				$('._bottom-fixed-footer').animate({'left': '200px'});
				$('#_form-settings').removeClass('show');
			},
			onClose: function(el) {
				$('._form-outlet').animate({'left': '0'});
				$('._bottom-fixed-footer').animate({'left': '0'});
				$("._top-menu-holder").removeClass('show');
			},
		});
	} else {
		$("._form-element-add").sideNav({
			menuWidth: 320,
			onOpen: function(el) {
				$('._form-outlet').animate({'left': '250px'});
				$('._bottom-fixed-footer').animate({'left': '320px'});
				$('#_form-settings').removeClass('show');
			},
			onClose: function(el) {
				$('._form-outlet').animate({'left': '0'});
				$('._bottom-fixed-footer').animate({'left': '0'});
				$('#_form-settings').removeClass('show');
			},
		});

		$("._form-details").sideNav({
			menuWidth: 320,
			onOpen: function(el) {
				$('._form-outlet').animate({'left': '250px'});
				$('._bottom-fixed-footer').animate({'left': '320px'});
				$('#_form-settings').removeClass('show');
			},
			onClose: function(el) {
				$('._form-outlet').animate({'left': '0'});
				$('._bottom-fixed-footer').animate({'left': '0'});
				$("._top-menu-holder").removeClass('show');
			},
		});

		$("._form-designs").sideNav({
			menuWidth: 320,
			onOpen: function(el) {
				$('._form-outlet').animate({'left': '250px'});
				$('._bottom-fixed-footer').animate({'left': '320px'});
				$('#_form-settings').removeClass('show');
			},
			onClose: function(el) {
				$('._form-outlet').animate({'left': '0'});
				$('._bottom-fixed-footer').animate({'left': '0'});
				$("._top-menu-holder").removeClass('show');
			},
		});
	}


	//form submission settings
	$('._open-settings').on('click', function() {
		if(!$(this).hasClass('active')) {
			$(this).parents('._top-menu-holder').parent().sideNav('hide');
			$('._form-holder > ._form-details').click();
		}
	});

	//design settings
	$('._open-designs').on('click', function() {
		if(!$(this).hasClass('active')) {
			$(this).parents('._top-menu-holder').parent().sideNav('hide');
			$('._form-holder > ._form-designs').click();
		}
	});

	// open element settings
	$('._open-form-settings').on('click', function() {
		if(!$(this).hasClass('active')) {
			$(this).parents('._top-menu-holder').parent().sideNav('hide');
			$('._form-holder ._form-element-add').click();
		}
	});

	//add design elements

	$('#layoutAddBtn').on('click', function() {
		var layoutJson = {};
		layoutJson['titleAlignment'] = 'Left';
		layoutJson['inputFieldBorderRadius'] = '0';
		var layoutJsonString = JSON.stringify(layoutJson);

		$('._form-holder').find('._form-designs').find('._form-designs-atr').attr('layout-json', layoutJsonString);
		addDesignsToElements(layoutJson, 'layout', layoutSettings);
	});

	$('#backgroundAddBtn').on('click', function() {
		var backgroundJson = {};
		backgroundJson['formBackgroundColor'] = '#fff';
		backgroundJson['inputFieldBackgroundColor'] = "#fff";
		backgroundJson['formBorderThickness'] = '0';
		backgroundJson['formBorderColor'] = "#fff";
		backgroundJson['formBorderRadius'] = "0";

		var backgroundJsonString = JSON.stringify(backgroundJson);

		$('._form-holder').find('._form-designs').find('._form-designs-atr').attr('background-json', backgroundJsonString);
		addDesignsToElements(backgroundJson, 'background', backgroundSettings);
	});

	$('#fontsAddBtn').on('click', function() {
		var fontsJson = {};
		fontsJson['titleFontColor'] = '#333';
		fontsJson['titleFontStyle'] = 'source-pro';
		fontsJson['titleFontSize'] = '16';
		fontsJson['labelFontColor'] = '#515356';
		fontsJson['labelFontStyle'] = 'source-pro';
		fontsJson['labelFontSize'] = '15';
		fontsJson['inputFontColor'] = '#555555';
		fontsJson['inputFontStyle'] = 'source-pro';
		fontsJson['inputFontSize'] = '14';

		var fontsJsonString = JSON.stringify(fontsJson);

		$('._form-holder').find('._form-designs').find('._form-designs-atr').attr('fonts-json', fontsJsonString);
		addDesignsToElements(fontsJson, 'fonts', fontsSettings);
	});

	$('#buttonsAddBtn').on('click', function() {
		var buttonsJson = {};
		buttonsJson['key'] = 1;

		var buttonsJsonString = JSON.stringify(buttonsJson);

		$('._form-holder').find('._form-designs').find('._form-designs-atr').attr('buttons-json', buttonsJsonString);
		addDesignsToElements(buttonsJson, 'buttons', buttonsSettings);
	});

	// add elements
	$('#locationAddBtn').on('click', function() {
		$(formContainer).append(locationInput);
		var formElementIndex = $('._form-element').length - 1;
		$(formContainer).find('._form-element').last().attr('data-index', formElementIndex);

		var locationJSON = {};
		locationJSON['key'] = formElementIndex;
		locationJSON['index'] = formElementIndex;
		locationJSON['type'] = 'location';
		locationJSON['label'] = 'Location';
		locationJSON['error'] = 'Error';
		locationJSON['helpText'] = '';
		locationJSON['locationType'] = 'searchbox'
		locationJSON['required'] = false;
		locationJSON['hasParent'] = false;
		locationJSON['isParent'] = false;

		var locationJSONString = JSON.stringify(locationJSON);

		$(formContainer).find('._form-element').last().attr('data-json', locationJSONString);
		addSettingsToElements($(formContainer).find('._form-element').last(), 'locationInput', locationInputSettings, formElementIndex);
	});

	$('#distanceMapBtn').on('click', function() {
		$(formContainer).append(distanceInput);
		var formElementIndex = $('._form-element').length - 1;
		$(formContainer).find('._form-element').last().attr('data-index', formElementIndex);

		var distanceJSON = {};
		distanceJSON['key'] = formElementIndex;
		distanceJSON['index'] = formElementIndex;
		distanceJSON['type'] = 'distance';
		distanceJSON['label'] = 'Locate distance';
		distanceJSON['error'] = 'Error';
		distanceJSON['helpText'] = '';
		distanceJSON['required'] = false;
		distanceJSON['hasParent'] = false;
		distanceJSON['isParent'] = false;

		var distanceJSONString = JSON.stringify(distanceJSON);

		$(formContainer).find('._form-element').last().attr('data-json', distanceJSONString);
		addSettingsToElements($(formContainer).find('._form-element').last(), 'distanceInput', distanceInputSettings, formElementIndex);
	});

	$('#textboxAddBtn').on('click', function() {
		$(formContainer).append(textboxInput);
		var formElementIndex = $('._form-element').length - 1;
		$(formContainer).find('._form-element').last().attr('data-index', formElementIndex);

		var textboxJSON = {};
		textboxJSON['key'] = formElementIndex;
		textboxJSON['index'] = formElementIndex;
		textboxJSON['type'] = 'textbox';
		textboxJSON['label'] = 'Textbox';
		textboxJSON['placeholder'] = 'Input Text Here';
		textboxJSON['error'] = 'Error';
		textboxJSON['helpText'] = '';
		textboxJSON['required'] = false;
		textboxJSON['hasParent'] = false;
		textboxJSON['isParent'] = false;

		var textboxJSONString = JSON.stringify(textboxJSON);

		$(formContainer).find('._form-element').last().attr('data-json', textboxJSONString);
		addSettingsToElements($(formContainer).find('._form-element').last(), 'textboxInput', textboxInputSettings, formElementIndex);
	});

	$('#textareaAddBtn').on('click', function() {
		$(formContainer).append(textareaInput);
		var formElementIndex = $('._form-element').length - 1;
		$(formContainer).find('._form-element').last().attr('data-index', formElementIndex);

		var textareaJSON = {};
		textareaJSON['key'] = formElementIndex;
		textareaJSON['index'] = formElementIndex;
		textareaJSON['type'] = 'textarea';
		textareaJSON['label'] = 'Textarea';
		textareaJSON['placeholder'] = 'Some text';
		textareaJSON['error'] = 'Error';
		textareaJSON['helpText'] = '';
		textareaJSON['required'] = false;
		textareaJSON['hasParent'] = false;
		textareaJSON['isParent'] = false;

		var textareaJSONString = JSON.stringify(textareaJSON);

		$(formContainer).find('._form-element').last().attr('data-json', textareaJSONString);
		addSettingsToElements($(formContainer).find('._form-element').last(), 'textareaInput', textareaInputSettings, formElementIndex);
	});

	$('#nameAddBtn').on('click', function() {
		$(formContainer).append(nameInput);
		var formElementIndex = $('._form-element').length - 1;
		$(formContainer).find('._form-element').last().attr('data-index', formElementIndex);

		var nameJSON = {};
		nameJSON['key'] = formElementIndex;
		nameJSON['index'] = formElementIndex;
		nameJSON['type'] = 'name';

		var firstNameJSON = {}
		firstNameJSON['label'] = 'First Name';
		firstNameJSON['inputType'] = 'text';
		firstNameJSON['placeholder'] = 'John';
		firstNameJSON['error'] = 'Error';

		var secondNameJSON = {}
		secondNameJSON['label'] = 'Last Name';
		secondNameJSON['inputType'] = 'text';
		secondNameJSON['placeholder'] = 'Doe';
		secondNameJSON['error'] = 'Error';

		nameJSON['fields'] = [];
		nameJSON['fields'][0] = firstNameJSON;
		nameJSON['fields'][1] = secondNameJSON;

		nameJSON['helpText'] = '';
		nameJSON['required'] = false;
		nameJSON['hasParent'] = false;
		nameJSON['isParent'] = false;

		var nameJSONString = JSON.stringify(nameJSON);

		$(formContainer).find('._form-element').last().attr('data-json', nameJSONString);
		addSettingsToElements($(formContainer).find('._form-element').last(), 'nameInput', nameInputSettings, formElementIndex);
	});

	$('#choiceAddBtn').on('click', function() {
		$(formContainer).append(choiceCheckboxInput);
		var formElementIndex = $('._form-element').length - 1;
		$(formContainer).find('._form-element').last().attr('data-index', formElementIndex);

		var choiceJSON = {};
		choiceJSON['key'] = formElementIndex;
		choiceJSON['index'] = formElementIndex;
		choiceJSON['type'] = 'choice';
		choiceJSON['choiceLabel'] = 'Choice';
		choiceJSON['error'] = 'Error';
		choiceJSON['choicePlaceholder1'] = 'Option 1';
		choiceJSON['newChoiceOptions'] = [];
		choiceJSON['choiceType'] = 'checkbox';
		choiceJSON['helpText'] = '';
		choiceJSON['required'] = false;
		choiceJSON['hasParent'] = false;
		choiceJSON['isParent'] = false;

		var choiceJSONString = JSON.stringify(choiceJSON);

		$(formContainer).find('._form-element').last().attr('data-json', choiceJSONString);
		addSettingsToElements($(formContainer).find('._form-element').last(), 'choiceCheckboxInput', choiceInputSettings, formElementIndex);
	});

	$('#coRelationAddBtn').on('click', function() {
		$(formContainer).append(coRelationDropdownInput);
		var formElementIndex = $('._form-element').length - 1;
		$(formContainer).find('._form-element').last().attr('data-index', formElementIndex);

		var relationJSON = {};
		relationJSON['key'] = formElementIndex;
		relationJSON['index'] = formElementIndex;
		relationJSON['error'] = 'Error';
		relationJSON['required'] = false;
		relationJSON['hasParent'] = false;
		relationJSON['isParent'] = false;
		relationJSON['selectMultiple'] = true;
		relationJSON['answerParent'] = false;
		relationJSON['type'] = 'correlation';
		relationJSON['formId'] = '';
		relationJSON['selectedRelationalElement'] = '';
		relationJSON['helpText'] = '';
		relationJSON['relationLabel'] = 'Relational';
		relationJSON['relationPlaceholder'] = 'Select your option';

		var relationJSONString = JSON.stringify(relationJSON);

		$(formContainer).find('._form-element').last().attr('data-json', relationJSONString);
		addSettingsToElements($(formContainer).find('._form-element').last(), 'coRelationDropdownInput', coRelationInputSettings, formElementIndex);
	});

	$('#paymentAddBtn').on('click', function() {
		$(formContainer).append(paymentRadioInput);
		var formElementIndex = $('._form-element').length - 1;
		$(formContainer).find('._form-element').last().attr('data-index', formElementIndex);

		var paymentJSON = {};
		paymentJSON['key'] = formElementIndex;
		paymentJSON['index'] = formElementIndex;
		paymentJSON['type'] = 'payment';
		paymentJSON['paymentLabel'] = 'Payment';
		paymentJSON['paymentType'] = 'radio';
		paymentJSON['productLabel1'] = 'Product 1';
		paymentJSON['productValue1'] = '';
		paymentJSON['productUrl1'] = 'http://www.example.com/';
		paymentJSON['newpaymentOptions'] = [];
		paymentJSON['helpText'] = '';
		paymentJSON['error'] = 'Error';
		paymentJSON['required'] = false;
		paymentJSON['hasParent'] = false;
		paymentJSON['isParent'] = false;

		var paymentJSONString = JSON.stringify(paymentJSON);

		$(formContainer).find('._form-element').last().attr('data-json', paymentJSONString);
		addSettingsToElements($(formContainer).find('._form-element').last(), 'paymentRadioInput', paymentInputSettings, formElementIndex);
	});

	$('#addressAddBtn').on('click', function() {
		$(formContainer).append(addressInput);
		var formElementIndex = $('._form-element').length - 1;
		$(formContainer).find('._form-element').last().attr('data-index', formElementIndex);
		$.get('https://www.letsendorse.com/getlocation?type=0').then(function(data) {
			for(var i = 0; i < data.length; i++) {
				$(formContainer).find('._form-element').last().find('select#country').append('<option value="' + data[i]['name'] + '" countryId="' + data[i]['id'] + '">' + data[i]['name'] + '</option>');
			}
		});
		$(formContainer).find('._form-element').last().find('select#country').change(function() {
			var $selectedCountry = $(this).find(':selected');
			var countryId = $selectedCountry.attr('countryId');
			$.get('https://www.letsendorse.com/getlocation?type=1&countryId=' + countryId).then(function(data) {
				for(var i = 0; i < data.length; i++) {
					$(formContainer).find('._form-element').last().find('select#state').append('<option value="' + data[i]['name'] + '" stateId="' + 	data[i]['id'] + '">' + data[i]['name'] + '</option>');
				}
			});
		});
		$(formContainer).find('._form-element').last().find('select#state').change(function() {
			var $selectedState = $(this).find(':selected');
			var stateId = $selectedState.attr('stateId');
			$.get('https://www.letsendorse.com/getlocation?type=2&stateId=' + stateId).then(function(data) {
				for(var i = 0; i < data.length; i++) {
					$(formContainer).find('._form-element').last().find('select#city').append('<option value="' + data[i]['name'] + '" cityId="' + data[i]['id'] + '">' + data[i]['name'] + '</option>');
				}
			});
		});

		var addressJSON = {};
		addressJSON['key'] = formElementIndex;
		addressJSON['index'] = formElementIndex;
		addressJSON['type'] = 'address';
		addressJSON['label'] = 'Address';

		var countryJSON = {}
		countryJSON['label'] = 'Country';
		countryJSON['type'] = 'country';
		countryJSON['inputType'] = 'select';
		countryJSON['error'] = 'Error';

		var stateJSON = {}
		stateJSON['label'] = 'State';
		stateJSON['type'] = 'state';
		stateJSON['inputType'] = 'select';
		stateJSON['error'] = 'Error';

		var cityJSON = {}
		cityJSON['label'] = 'City';
		cityJSON['type'] = 'city';
		cityJSON['inputType'] = 'select';
		cityJSON['error'] = 'Error';

		var pincodeJSON = {}
		pincodeJSON['label'] = 'Pincode';
		pincodeJSON['type'] = 'pincode';
		pincodeJSON['inputType'] = 'text';
		pincodeJSON['placeholder'] = 'Enter pincode';
		pincodeJSON['error'] = 'Error';

		var areaJSON = {}
		areaJSON['label'] = 'Area';
		areaJSON['type'] = 'area';
		areaJSON['inputType'] = 'text';
		areaJSON['placeholder'] = 'Enter area';
		areaJSON['error'] = 'Error';

		var streetJSON = {}
		streetJSON['label'] = 'Street';
		streetJSON['type'] = 'street';
		streetJSON['inputType'] = 'text';
		streetJSON['placeholder'] = 'Enter street';
		streetJSON['error'] = 'Error';

		addressJSON['fields'] = [];
		addressJSON['fields'][0] = countryJSON;
		addressJSON['fields'][1] = stateJSON;
		addressJSON['fields'][2] = cityJSON;
		addressJSON['fields'][3] = pincodeJSON;
		addressJSON['fields'][4] = areaJSON;
		addressJSON['fields'][5] = streetJSON;

		addressJSON['helpText'] = '';
		addressJSON['required'] = false;
		addressJSON['hasParent'] = false;
		addressJSON['isParent'] = false;
		addressJSON['geoLocation'] = false;

		var addressJSONString = JSON.stringify(addressJSON);

		$(formContainer).find('._form-element').last().attr('data-json', addressJSONString);
		addSettingsToElements($(formContainer).find('._form-element').last(), 'addressInput', addressInputSettings, formElementIndex);
	});

	$('#yesnoAddBtn').on('click', function() {
		$(formContainer).append(yesnoInput);
		var formElementIndex = $('._form-element').length - 1;
		$(formContainer).find('._form-element').last().attr('data-index', formElementIndex);

		var yesnoJSON = {};
		yesnoJSON['key'] = formElementIndex;
		yesnoJSON['index'] = formElementIndex;
		yesnoJSON['type'] = 'yesno';
		yesnoJSON['error'] = 'Error';
		yesnoJSON['yesnoLabel'] = 'Yes/No';
		yesnoJSON['yesnoPlaceholder1'] = 'Yes';
		yesnoJSON['yesnoPlaceholder2'] = 'No';
		yesnoJSON['helpText'] = '';
		yesnoJSON['required'] = false;
		yesnoJSON['hasParent'] = false;
		yesnoJSON['isParent'] = false;

		var yesnoJSONString = JSON.stringify(yesnoJSON);

		$(formContainer).find('._form-element').last().attr('data-json', yesnoJSONString);
		addSettingsToElements($(formContainer).find('._form-element').last(), 'yesnoInput', yesnoInputSettings, formElementIndex);
	});

	$('#phoneAddBtn').on('click', function() {
		$(formContainer).append(phoneInput);
		var formElementIndex = $('._form-element').length - 1;
		$(formContainer).find('._form-element').last().attr('data-index', formElementIndex);
		$(formContainer).find('._form-element').last().find("#phone").intlTelInput();

		var phoneJSON = {};
		phoneJSON['key'] = formElementIndex;
		phoneJSON['index'] = formElementIndex;
		phoneJSON['type'] = 'phone';
		phoneJSON['label'] = 'Phone';
		phoneJSON['error'] = 'Error';
		phoneJSON['helpText'] = '';
		phoneJSON['required'] = false;
		phoneJSON['hasParent'] = false;
		phoneJSON['isParent'] = false;

		var phoneJSONString = JSON.stringify(phoneJSON);

		$(formContainer).find('._form-element').last().attr('data-json', phoneJSONString);
		addSettingsToElements($(formContainer).find('._form-element').last(), 'phoneInput', phoneInputSettings, formElementIndex);
	})

	$('#dateAddBtn').on('click', function() {
		$(formContainer).append(dateInput);
		var formElementIndex = $('._form-element').length - 1;
		$(formContainer).find('._form-element').last().attr('data-index', formElementIndex);
		// $('.datepicker').pickadate({
		// 		selectMonths: true, // Creates a dropdown to control month
		// 		selectYears: 15 // Creates a dropdown of 15 years to control year
		// });
		$('.datepicker-here').datepicker({language: 'en', dateFormat: 'dd/mm/yyyy'});

		var dateJSON = {};
		dateJSON['key'] = formElementIndex;
		dateJSON['index'] = formElementIndex;
		dateJSON['type'] = 'date';
		dateJSON['label'] = 'Date';
		dateJSON['error'] = 'Error';
		dateJSON['helpText'] = '';
		dateJSON['required'] = false;
		dateJSON['hasParent'] = false;
		dateJSON['isParent'] = false;

		var dateJSONString = JSON.stringify(dateJSON);

		$(formContainer).find('._form-element').last().attr('data-json', dateJSONString);
		addSettingsToElements($(formContainer).find('._form-element').last(), 'dateInput', dateInputSettings, formElementIndex);
	});

	$('#timeAddBtn').on('click', function() {
		$(formContainer).append(timeInput);
		var formElementIndex = $('._form-element').length - 1;
		$(formContainer).find('._form-element').last().attr('data-index', formElementIndex);
		$('.timepicker').pickatime({
			default: 'now', // Set default time
			fromnow: 0,       // set default time to * milliseconds from now (using with default = 'now')
			twelvehour: true, // Use AM/PM or 24-hour format
			donetext: 'OK', // text for done-button
			cleartext: 'Clear', // text for clear-button
			canceltext: 'Cancel', // Text for cancel-button
			autoclose: false, // automatic close timepicker
			ampmclickable: true, // make AM PM clickable
			aftershow: function(){} //Function for after opening timepicker
		});

		var timeJSON = {};
		timeJSON['key'] = formElementIndex;
		timeJSON['index'] = formElementIndex;
		timeJSON['type'] = 'time';
		timeJSON['label'] = 'Time';
		timeJSON['error'] = 'Error';
		timeJSON['helpText'] = '';
		timeJSON['required'] = false;
		timeJSON['hasParent'] = false;
		timeJSON['isParent'] = false;

		var timeJSONString = JSON.stringify(timeJSON);

		$(formContainer).find('._form-element').last().attr('data-json', timeJSONString);
		addSettingsToElements($(formContainer).find('._form-element').last(), 'timeInput', timeInputSettings, formElementIndex);
	});

	$('#emailAddBtn').on('click', function() {
		$(formContainer).append(emailInput);
		var formElementIndex = $('._form-element').length - 1;
		$(formContainer).find('._form-element').last().attr('data-index', formElementIndex);

		var emailJSON = {};
		emailJSON['key'] = formElementIndex;
		emailJSON['index'] = formElementIndex;
		emailJSON['type'] = 'email';
		emailJSON['label'] = 'Email';
		emailJSON['error'] = 'Error';
		emailJSON['placeholder'] = 'email@example.com';
		emailJSON['helpText'] = '';
		emailJSON['required'] = false;
		emailJSON['hasParent'] = false;
		emailJSON['isParent'] = false;

		var emailJSONString = JSON.stringify(emailJSON);

		$(formContainer).find('._form-element').last().attr('data-json', emailJSONString);
		addSettingsToElements($(formContainer).find('._form-element').last(), 'emailInput', emailInputSettings, formElementIndex);
	});

	$('#numberAddBtn').on('click', function() {
		$(formContainer).append(numberInput);
		var formElementIndex = $('._form-element').length - 1;
		$(formContainer).find('._form-element').last().attr('data-index', formElementIndex);

		var numberJSON = {};
		numberJSON['key'] = formElementIndex;
		numberJSON['index'] = formElementIndex;
		numberJSON['type'] = 'number';
		numberJSON['label'] = 'Number';
		numberJSON['error'] = 'Error';
		numberJSON['placeholder'] = '100';
		numberJSON['helpText'] = '';
		numberJSON['required'] = false;
		numberJSON['hasParent'] = false;
		numberJSON['isParent'] = false;

		var numberJSONString = JSON.stringify(numberJSON);

		$(formContainer).find('._form-element').last().attr('data-json', numberJSONString);
		addSettingsToElements($(formContainer).find('._form-element').last(), 'numberInput', numberInputSettings, formElementIndex);
	});

	$('#websiteAddBtn').on('click', function() {
		$(formContainer).append(websiteInput);
		var formElementIndex = $('._form-element').length - 1;
		$(formContainer).find('._form-element').last().attr('data-index', formElementIndex);

		var websiteJSON = {};
		websiteJSON['key'] = formElementIndex;
		websiteJSON['index'] = formElementIndex;
		websiteJSON['type'] = 'website';
		websiteJSON['label'] = 'Website';
		websiteJSON['error'] = 'Error';
		websiteJSON['placeholder'] = 'https://www.example.com';
		websiteJSON['helpText'] = '';
		websiteJSON['required'] = false;
		websiteJSON['hasParent'] = false;
		websiteJSON['isParent'] = false;

		var websiteJSONString = JSON.stringify(websiteJSON);

		$(formContainer).find('._form-element').last().attr('data-json', websiteJSONString);
		addSettingsToElements($(formContainer).find('._form-element').last(), 'websiteInput', websiteInputSettings, formElementIndex);
	});

	$('#currencyAddBtn').on('click', function() {
		$(formContainer).append(currencyInput);
		var formElementIndex = $('._form-element').length - 1;
		$(formContainer).find('._form-element').last().attr('data-index', formElementIndex);

		var currencyJSON = {};
		currencyJSON['key'] = formElementIndex;
		currencyJSON['index'] = formElementIndex;
		currencyJSON['type'] = 'currency';
		currencyJSON['label'] = 'Currency';
		currencyJSON['error'] = 'Error';
		currencyJSON['currencySymbol'] = 'Rs';
		currencyJSON['helpText'] = '';
		currencyJSON['required'] = false;
		currencyJSON['hasParent'] = false;
		currencyJSON['isParent'] = false;

		var currencyJSONString = JSON.stringify(currencyJSON);

		$(formContainer).find('._form-element').last().attr('data-json', currencyJSONString);
		addSettingsToElements($(formContainer).find('._form-element').last(), 'currencyInput', currencyInputSettings, formElementIndex);
	});

	$('#scaleAddBtn').on('click', function() {
		$(formContainer).append(scaleInput);
		var formElementIndex = $('._form-element').length - 1;
		$(formContainer).find('._form-element').last().attr('data-index', formElementIndex);

		var scaleJSON = {};
		scaleJSON['key'] = formElementIndex;
		scaleJSON['index'] = formElementIndex;
		scaleJSON['type'] = 'scale';
		scaleJSON['label'] = 'Scale';
		scaleJSON['error'] = 'Error';
		scaleJSON['scaleCount'] = '3';
		scaleJSON['helpText'] = '';
		scaleJSON['required'] = false;
		scaleJSON['hasParent'] = false;
		scaleJSON['isParent'] = false;

		var scaleJSONString = JSON.stringify(scaleJSON);

		$(formContainer).find('._form-element').last().attr('data-json', scaleJSONString);
		addSettingsToElements($(formContainer).find('._form-element').last(), 'scaleInput', scaleInputSettings, formElementIndex);
	})

	$('#signatureAddBtn').on('click', function() {
		$(formContainer).append(signatureInput);
		var formElementIndex = $('._form-element').length - 1;
		$(formContainer).find('._form-element').last().attr('data-index', formElementIndex);

		var signatureJSON = {};
		signatureJSON['key'] = formElementIndex;
		signatureJSON['index'] = formElementIndex;
		signatureJSON['type'] = 'signature';
		signatureJSON['label'] = 'Signature';
		signatureJSON['error'] = 'Error';
		signatureJSON['helpText'] = '';
		signatureJSON['required'] = false;
		signatureJSON['hasParent'] = false;
		signatureJSON['isParent'] = false;

		var signatureJSONString = JSON.stringify(signatureJSON);

		$(formContainer).find('._form-element').last().attr('data-json', signatureJSONString);
		addSettingsToElements($(formContainer).find('._form-element').last(), 'signatureInput', signatureInputSettings, formElementIndex);
	})

	$('#areamapAddBtn').on('click', function() {
		$(formContainer).append(areaMapInput);
		var formElementIndex = $('._form-element').length - 1;
		$(formContainer).find('._form-element').last().attr('data-index', formElementIndex);

		var areaMapJSON = {};
		areaMapJSON['key'] = formElementIndex;
		areaMapJSON['index'] = formElementIndex;
		areaMapJSON['type'] = 'areamap';
		areaMapJSON['label'] = 'Locate Area';
		areaMapJSON['error'] = 'Error';
		areaMapJSON['helpText'] = '';
		areaMapJSON['required'] = false;
		areaMapJSON['hasParent'] = false;
		areaMapJSON['isParent'] = false;

		var areaMapJSONString = JSON.stringify(areaMapJSON);

		$(formContainer).find('._form-element').last().attr('data-json', areaMapJSONString);
		addSettingsToElements($(formContainer).find('._form-element').last(), 'areaMapInput', areaMapInputSettings, formElementIndex);
	})

	$('#barcodeAddBtn').on('click', function() {
		$(formContainer).append(barcodeInput);
		var formElementIndex = $('._form-element').length - 1;
		$(formContainer).find('._form-element').last().attr('data-index', formElementIndex);

		var barcodeJSON = {};
		barcodeJSON['key'] = formElementIndex;
		barcodeJSON['index'] = formElementIndex;
		barcodeJSON['type'] = 'barcode';
		barcodeJSON['label'] = 'barcode';
		barcodeJSON['error'] = 'Error';
		barcodeJSON['helpText'] = '';
		barcodeJSON['required'] = false;
		barcodeJSON['hasParent'] = false;
		barcodeJSON['isParent'] = false;

		var barcodeJSONString = JSON.stringify(barcodeJSON);

		$(formContainer).find('._form-element').last().attr('data-json', barcodeJSONString);
		addSettingsToElements($(formContainer).find('._form-element').last(), 'barcodeInput', barcodeInputSettings, formElementIndex);
	})

	$('#ratingAddBtn').on('click', function() {
		$(formContainer).append(ratingInput);
		var formElementIndex = $('._form-element').length - 1;
		$(formContainer).find('._form-element').last().attr('data-index', formElementIndex);
		$(".my-rating").starRating({
			totalStars: 3,
			starSize: 25,
			disableAfterRate: false,
		});
		var ratingJSON = {};
		ratingJSON['key'] = formElementIndex;
		ratingJSON['index'] = formElementIndex;
		ratingJSON['type'] = 'rating';
		ratingJSON['label'] = 'Rating';
		ratingJSON['error'] = 'Error';
		ratingJSON['ratingCount'] = '3';
		ratingJSON['helpText'] = '';
		ratingJSON['required'] = false;
		ratingJSON['hasParent'] = false;
		ratingJSON['isParent'] = false;

		var ratingJSONString = JSON.stringify(ratingJSON);

		$(formContainer).find('._form-element').last().attr('data-json', ratingJSONString);
		addSettingsToElements($(formContainer).find('._form-element').last(), 'ratingInput', ratingInputSettings, formElementIndex);
	})

	$('#fileAddBtn').on('click', function() {
		$(formContainer).append(fileInput);
		var formElementIndex = $('._form-element').length - 1;
		$(formContainer).find('._form-element').last().attr('data-index', formElementIndex);

		var fileJSON = {};
		fileJSON['key'] = formElementIndex;
		fileJSON['index'] = formElementIndex;
		fileJSON['type'] = 'file';
		fileJSON['label'] = 'File';
		fileJSON['error'] = 'Error';
		fileJSON['fileType'] = '*';
		fileJSON['helpText'] = '';
		fileJSON['multipleSelect'] = false;
		fileJSON['required'] = false;
		fileJSON['geoTag'] = false;
		fileJSON['hasParent'] = false;
		fileJSON['isParent'] = false;

		var fileJSONString = JSON.stringify(fileJSON);

		$(formContainer).find('._form-element').last().attr('data-json', fileJSONString);
		addSettingsToElements($(formContainer).find('._form-element').last(), 'fileInput', fileInputSettings, formElementIndex);
	});

	$('#pagebreakAddBtn').on('click', function() {
		$(formContainer).append(pagebreakInput);

		var pagebreakJSON = {};
		pagebreakJSON['key'] = formElementIndex;
		pagebreakJSON['index'] = formElementIndex;
		pagebreakJSON['type'] = 'pagebreak';
		pagebreakJSON['hasParent'] = false;
		pagebreakJSON['isParent'] = false;

		var pagebreakJSONString = JSON.stringify(pagebreakJSON);

		var formElementIndex = $('._form-element').length - 1;
		$(formContainer).find('._form-element').last().attr('data-index', formElementIndex);
		$(formContainer).find('._form-element').last().attr('data-json', pagebreakJSONString);
	});

	$('#headerAddBtn').on('click', function() {
		$(headerContainer).append(headerInput);
		var headerJSON = {};
		headerJSON['headerTitle'] = 'Title';
		headerJSON['headerSubtitle'] = 'Subtitle';
		headerJSON['headerBackground'] = 'https://static.pexels.com/photos/55787/pexels-photo-55787.jpeg';
		headerJSON['required'] = false;
		var headerJSONString = JSON.stringify(headerJSON);

		$(headerContainer).find('._form-element').first().attr('data-json', headerJSONString);
		addSettingsToElements($(headerContainer).find('._form-element').first(), 'headerInput', headerInputSettings, 0);
	});

	$('#contentAddBtn').on('click', function() {
		$(formContainer).append(contentInput);
		var formElementIndex = $('._form-element').length - 1;
		$(formContainer).find('._form-element').last().attr('data-index', formElementIndex);

		var contentJSON = {};
		contentJSON['key'] = formElementIndex;
		contentJSON['index'] = formElementIndex;
		contentJSON['type'] = 'content';
		contentJSON['contentText'] = 'Title';
		contentJSON['hasParent'] = false;
		contentJSON['isParent'] = false;
		var contentJSONString = JSON.stringify(contentJSON);

		$(formContainer).find('._form-element').last().attr('data-json', contentJSONString);
		addSettingsToElements($(formContainer).find('._form-element').last(), 'contentInput', contentInputSettings, formElementIndex);
	});

	$(document.body).on('click', '._delete-element', function() {
		var currentElement = $(this).parent().parent().parent();
		var index = $(currentElement).data('index'), elementsLength;

		if($('._form-element[data-parentIndex=' + index + ']').length) {
			swal({
				title: 'Are you sure?',
				text: 'There are other elements which are dependent on this element. Delete the one with the dependencies first.',
				type: 'warning',
				confirmButtonColor: '#ef5a20',
				confirmButtonText: 'Okay',
			}).then(function(result) {
				if (result) {
					$('._form-element[data-parentIndex=' + index + ']').each(function(){
						$(this).css("border-color", "red");
						$(this).css("transition", "all ease 0.3");
					});
					setTimeout(function(){
						$('._form-element[data-parentIndex=' + index + ']').each(function(){
							$(this).css("border-color", "#f1f1f1");
							$(this).css("transition", "all ease 0.3");
						});
					}, 3000);
				}
			}).catch(function() {});
		} else {
			$(currentElement).remove();
			elementsLength = $(formContainer).find('._form-element').length;
			for(let i = 0; i < elementsLength; i++) {
				var dataJSON = $(formContainer).find('._form-element').eq(i).attr('data-json');
				dataJSON = JSON.parse(dataJSON);
				var oldParentIndex = dataJSON.key;
				if($('._form-element[data-parentIndex=' + oldParentIndex + ']').length) {
					$('._form-element[data-parentIndex=' + oldParentIndex + ']').each(function(j) {
						var parentOldJSON = $(this).attr('data-parent');
						parentOldJSON = JSON.parse(parentOldJSON);

						parentOldJSON.parentIndex = i;
						parentOldJSON.selectedParentData.key = i;
						parentOldJSON.selectedParentData.index = i;

						$(this).data('parentIndex', i);
						$(this).attr('data-parentIndex', String(i));
						$(this).data('parent', parentOldJSON);
						$(this).attr('data-parent', JSON.stringify(parentOldJSON));
					});
				}
				dataJSON.key = i;
				dataJSON.index = i;
				$(formContainer).find('._form-element').eq(i).data('index', i);
				$(formContainer).find('._form-element').eq(i).attr('data-index', String(i));
				$(formContainer).find('._form-element').eq(i).data('json', dataJSON);
				$(formContainer).find('._form-element').eq(i).attr('data-json', JSON.stringify(dataJSON));
			}
		}
	});
});

function getAllChildrenCount(parentIndex, count) {
	$('._form-element[data-parentIndex=' + parentIndex + ']').each(function(index) {
		var ownIndex = $(this).data('index'), totalChildren = $('._form-element[data-parentIndex=' + ownIndex + ']').length;
		if(totalChildren) count = getAllChildrenCount(ownIndex, count);
		count += 1;
	});
	return count;
}

function removeAllChildren(parentIndex, cb) {
	$('._form-element[data-parentIndex=' + parentIndex + ']').each(function(index) {
		var ownIndex = $(this).data('index'), $selectedElem = $(this),
			totalChildren = $('._form-element[data-parentIndex=' + ownIndex + ']').length;

		if(totalChildren) {
			removeAllChildren(ownIndex, function() {
				$($selectedElem).remove();
				cb();
			});
		} else {
			$($selectedElem).remove();
			cb();
		}
	});
}